<!-- apps/frontend/src/components/flow/nodes/ExitNodeBadge.vue -->
<!-- Segnala che il nodo chiude il flusso: nessun arco uscente e tipo che non
     richiede un seguito (vedi utils/flowExitNodes.js). -->
<template>
  <span
    v-if="active"
    class="material-icons text-green-400 text-base"
    role="img"
    :aria-label="$t('flowEditor.nodeEditorPanel.exitNodeTooltip')"
    v-tooltip="$t('flowEditor.nodeEditorPanel.exitNodeTooltip')"
  >logout</span>
</template>

<script setup>
defineProps({
  active: { type: Boolean, default: false },
});
</script>
